import { any, IOWidget, Updater } from 'widgets-for-react'
import { PublicSiteState } from '../../../../../root/state'
import { renderBlock } from '../../cms/blocks/block_to_widget.gen'
import { DownloadBlock } from '../../cms/blocks/widgets/downloadBlock.gen'
import { DownloadBlockNested } from '../../cms/blocks/widgets/downloadBlockNested.gen'
import { FeaturedContentBlock } from '../../cms/blocks/widgets/featuredContentBlock.gen'
import { IframeBlock } from '../../cms/blocks/widgets/iframeBlock.gen'
import { ImageGalleryBlock } from '../../cms/blocks/widgets/imageGalleryBlock.gen'
import { LinkBlock } from '../../cms/blocks/widgets/linkBlock.gen'
import { LinkGridBlock } from '../../cms/blocks/widgets/linkGridBlock.gen'
import { MediaBlock } from '../../cms/blocks/widgets/mediaBlock.gen'
import { MediaBlockNested } from '../../cms/blocks/widgets/mediaBlockNested.gen'
import { QuoteBlock } from '../../cms/blocks/widgets/quoteBlock.gen'
import { QuoteBlockNested } from '../../cms/blocks/widgets/quoteBlockNested.gen'
import { TextBlockNested } from '../../cms/blocks/widgets/textBlockNested.gen'
import { TextImageBlock } from '../../cms/blocks/widgets/textImageBlock.gen'
import { TextReadMoreBlock } from '../../cms/blocks/widgets/textReadMoreBlock.gen'
import { TemplateState } from '../../cms/page/types.gen'
import { isCustomBlockData, renderCustomBlock } from './custom_blocks/types.mod'

export const pageDisplay =
  (
    public_state: PublicSiteState,
    set_public_site_state: (output: Updater<PublicSiteState>) => void
  ): IOWidget<TemplateState, Updater<TemplateState>> =>
  (s) =>
    any([
      ...s.blocks
        .map((b, index) => {
          let res = isCustomBlockData(b)
            ? renderCustomBlock(
                b,
                public_state,
                set_public_site_state
              )(s).map(
                (a) =>
                  (s1: TemplateState): TemplateState => ({ ...s1, ...a(s1) })
              )
            : renderBlock(
                b,
                {
                  featuredContentBlock: FeaturedContentBlock,
                  textImageBlock: TextImageBlock,
                  mediaBlock: MediaBlock,
                  mediaBlockNested: MediaBlockNested,
                  linkGridBlock: LinkGridBlock,
                  linkBlock: LinkBlock,
                  downloadBlock: DownloadBlock,
                  downloadBlockNested: DownloadBlockNested,
                  textBlockNested: TextBlockNested,
                  textReadMoreBlock: TextReadMoreBlock,
                  quoteBlock: QuoteBlock,
                  quoteBlockNested: QuoteBlockNested,
                  imageGalleryBlock: ImageGalleryBlock,
                  iframeBlock: IframeBlock
                },
                set_public_site_state,
                public_state,
                `key-${index}`
              )(s).map<Updater<TemplateState>>((a) => (s1) => {
                const res = a(s1)
                return { ...s1, images: res.images, blocks: res.blocks }
              })
          return res
        })
        .toArray()
    ])
